import { InfoIcon } from 'lucide-react'

import { type PlanType } from 'components/plan_selection_preference/type'
import { Badge, Tooltip } from 'slab'

import { useOnboarding } from '../OnboardingContext'
import { HsaBadge } from './HsaBadge/HsaBadge'
import { type MetalTier, MetalTierBadge } from './MetalTierBadge/MetalTierBadge'
import { PlanBadge } from './PlanBadge/PlanBadge'

type MedicalPlanBadgesProps = {
  // For look
  bordered?: boolean
  // For logic
  planHsaEligible?: boolean
  planMetalTier?: MetalTier
  planType?: PlanType
  showPurchasedByYou?: boolean
}

export const MedicalPlanBadges = ({
  bordered = false,
  planHsaEligible,
  planMetalTier,
  planType,
  showPurchasedByYou,
}: MedicalPlanBadgesProps) => {
  const { onboardingData } = useOnboarding()
  const isUserQmeEligible = onboardingData?.allowance?.qme_treatment === 'all_allowed'
  return (
    <div className='flex flex-wrap gap-2'>
      {planMetalTier && <MetalTierBadge bordered={bordered} tier={planMetalTier} />}
      {planType && <PlanBadge bordered={bordered} type={planType} />}
      {planHsaEligible && <HsaBadge bordered={bordered} isUserQmeEligible={isUserQmeEligible} />}
      {showPurchasedByYou && (
        <Badge bordered={bordered} type='info'>
          <div className='flex items-center gap-1'>
            Purchased by you{' '}
            <Tooltip content="Thatch won't enroll you or make any payments for this plan">
              <InfoIcon
                aria-label='More information'
                className='cursor-help'
                size={14}
              />
            </Tooltip>
          </div>
        </Badge>
      )}
    </div>
  )
}
